import { ChangeDetectionStrategy, Component, ViewEncapsulation, input, output } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { CerrixTreeIconViewerComponent } from "../cerrix-tree-icon-viewer/cerrix-tree-icon-viewer.component";

/**
 * Looks like a select field but has no dropdown: it shows the item that was picked
 * elsewhere (a dialog, a picker) and asks to be pressed to pick another one.
 */
@Component({
    selector: "app-cerrix-picker-field",
    imports: [MatIconModule, CerrixTreeIconViewerComponent],
    templateUrl: "./cerrix-picker-field.component.html",
    styleUrl: "./cerrix-picker-field.component.scss",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    // The validation directives resolve a field by its name attribute, which a [name] property
    // binding on this component does not leave behind.
    host: {
        "[attr.name]": "name()",
    },
})
export class CerrixPickerFieldComponent {
    /** Name of the picked item. Empty means nothing is picked, so the placeholder shows instead. */
    readonly text = input("");

    /** Icon of the picked item; left out when the item has none. */
    readonly icon = input("");

    /** Icon of the picked item; left out when the item has none. */
    readonly treeIcon = input("");

    readonly placeholder = input("");
    readonly disabled = input(false);

    /** Doubles as the field's id, so a <cerrix-label [for]> can name it. */
    readonly name = input("");

    readonly pressed = output<void>();
}
